module.exports = {
      id: "thesis-usage",
      viewBox: "0 0 353.6 318.52",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#thesis-usage",
      toString: function () {
        return this.url;
      }
    }